import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { FIELD_LENGTH, InputText, StringUtilService, ValidationService } from '@sm360/widget-commons-forms';

class InputZipCode extends React.Component {
    constructor(props) {
        super(props);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.validInput = this.validInput.bind(this);
    }

    validInput(value) {
        const trimValue = StringUtilService.removeSpaces(value);
        const validation = ValidationService.validateZipCode(trimValue, this.props.country);

        if (this.props.isRequired) {
            return validation && ValidationService.validateIsNotEmpty(trimValue);
        }

        return isEmpty(value) || validation;
    }

    handleInputChange(value) {
        const maskValue = StringUtilService.formatPostalCode(value, this.props.country);

        this.props.valueChange({
            value: maskValue,
            validation: this.validInput(maskValue),
        });
    }

    render() {
        return (
            <InputText
                type="text"
                name="postalCode"
                classNames={this.props.classNames}
                value={StringUtilService.formatPostalCode(this.props.value, this.props.country)}
                label={
                    this.props.country === 'us'
                        ? LocaleService.t('LOGIN.PROFILE.ZIP_CODE')
                        : LocaleService.t('LOGIN.PROFILE.POSTAL_CODE')
                }
                isRequired={this.props.isRequired}
                isValid={this.props.isValid}
                valueChange={this.handleInputChange}
                maxLength={FIELD_LENGTH.POSTAL_CODE_MAX}
            />
        );
    }
}

InputZipCode.propTypes = {
    value: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    classNames: PropTypes.arrayOf(PropTypes.string),
    isRequired: PropTypes.bool,
    valueChange: PropTypes.func.isRequired,
};

InputZipCode.displayName = 'InputZipCode';

export default InputZipCode;
